import styled from 'styled-components';

interface RowProps {
    reverse?: boolean;
}

export const PageWrapper = styled.div`
    background: #EAF7F0;
`
export const BestRateSection = styled.div`
    display: flex;
    flex-direction: column;
    padding: 120px 0;
    align-items: center;
    h3 {
      color: #299B85;
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px;
    };
    h2{
      color: #212529;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 50px; /* 125% */
      margin-top: 16px;
    }
    .line{
      width: 80px;
      height: 3px;
      background: #6ECFB2;
      margin: 0 auto;
      margin-top: 24px;
    }
    p{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #666;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
    }
`
export const BestRateSlider = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  padding: 120px 0;
  align-items: stretch;
  width: 100%;

  @media (min-width: 768px) {
    & > * {
      flex: 1 1 calc(50% - 25px);
      min-width: 0;
    }
  }

  @media (max-width: 767px) {
    & > * {
      flex: 1 1 100%;
    }
  }
`;

export const RateSliderBox = styled.div`
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.10), 0 4px 15px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 calc(50% - 25px);
  min-width: 0;
  
  .text-box {
    padding: 25px;
    h4{
      margin-bottom: 24px;
    }
    p {
      text-align: left;
    }
  }
  .icon-box { 
    min-height: 390px;
    background: #f8fbf9;
    width: 100%;
    flex: 1 1 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  
  @media (max-width: 767px) {
    flex: 1 1 100%;
  }
`;


export const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: space-between;
    padding: 64px 0;
    padding-top: 30px;

    img {
        max-width: 580px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 0px 0 80px;
        img {
            max-width: 100%;
        }
    }
`
export const Slider = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-around;
    max-width: 1200px;
    width: 100%;
    
    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 20px;
    }
`

export const SliderBox = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 230px;
    gap: 20px;
    text-align: center;
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    line-height: 25.5px; 
    color: #212529;
    
    @media (max-width: 768px) {
        flex: 1 1 calc(50% - 10px);
        min-width: 140px;
        max-width: calc(50% - 10px);
    }
`


export const TopSectionMain = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 44px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
        font-size: 54px;
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
        color: #212529;
        text-align: center;
    }

    p {
        font-size: 17px;
        color: #333333;
        line-height: 25px;
        letter-spacing: 0.5px;
        text-align: center;
    }

    .home-p {
        font-family: sans-serif;
    }

    @media (max-width: 991px) {
        h1 {
            font-size: 36px;
            font-weight: 700;
            line-height: 44px;
            margin-bottom: 24px;
        }

        p {
            margin-bottom: 24px;
        }
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`


export const SectionContent = styled.div`
    padding: 80px 0px;
    text-align: center;

    h2 {
        font-size: 40px;
        line-height: 50px;
        color: #212529;
        font-weight: 700;
    }

    h3 {
        font-size: 24px;
        line-height: 30px;
        color: #299B85;
        font-weight: 700;
    }


    p {
        max-width: 460px;
        display: block;
        margin: 0 auto 20px;
        font-size: 16px;
        line-height: 24px;
        color: #666666;
    }

    @media (max-width: 768px) {
        padding: 40px 0;

        h2 {
            font-size: 22px;
        }

        p {
            max-width: 100%;
        }

        button {
            margin-bottom: 15px;
        }
    }
`

export const PartnerSection = styled.div`
    padding: 80px 0;

    h2 {
        text-align: center;
        font-weight: 700;
        font-size: 36px;
        line-height: 42px;
        max-width: 50%;
        display: block;
        margin: 0 auto 30px;
    }

    @media (max-width: 768px) {
        padding: 40px 0;

        h2 {
            max-width: 80%;
            font-size: 22px;
            line-weight: 36px;
        }
    }
`
export const ProgramSection = styled.div`
    padding-top: 120px;
    padding-bottom: 120px;
    background: radial-gradient(384.01% 126.3% at 92.67% 89.43%, #005242 32.71%, #006451 100%), #FFF;
    h4 {
        font-size: 24px;
        color: #6ECFB2;
        text-align: center;
        font-weight: 700;
        margin-bottom: 18px
    }
        
    .line{
      width: 80px;
      height: 3px;
      background: #6ECFB2;
      margin: 0 auto;
      margin-top: 24px;
      margin-bottom: 40px;
    }

    h3 {
        color: #fff;
        font-size: 40px;
        text-align: center;
        font-weight: 700;
        line-height: 50px;
        width: 50%;
        margin: 0 auto 18px; 
    }

    @media (max-width: 768px) {
        padding-top: 80px;
        padding-bottom: 80px;

        h4 {
            font-size: 20px;
            font-weight: 700;
            line-height: 30px;
        }
        h3 {
            width: 100%;
            font-size: 28px;
            line-height: 36px;
        }
    }
`

export const SectionRow = styled.div<RowProps>`
    display: flex;
    flex-direction: ${props => props.reverse ? 'row-reverse' : 'row'};
    align-items: center;
    justify-content: space-between;
    padding: 22px 88px;
    background: #066A56;
    border-radius: 16px;
    box-shadow: 0 8px 25px 0 rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 22px;
    }
`
export const ProgramSectionContent = styled.div`
    padding: 0 44px;

    h2 {
        margin-bottom: 24px;
        font-weight: 700;
        font-size: 32px;
        color: #fff;
    }

    p {
        color: #F5F8FF;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.5px;
        font-family: sans-serif;

    }

    button {
        margin-left: auto;
        display: block;
    }
    .step-title {
        color: #6ECFB2;
        font-weight: 700;
        font-size: 17px;
        line-height: 24px;
    }

    @media (max-width: 768px) {
        padding-left: 0;
        padding-right: 0;

        h2 {
            font-size: 22px;
        }

        button {
            margin-bottom: 15px;
            width: 100%;
        }
    }
`

export const SectionImg = styled.div`
    flex-shrink: 0;
    flex-basis: 25%;
    img {
        max-height: 200px;
    }

    @media (max-width: 768px) {
        max-width: 100%;
    }
`